var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"toast cut-border"},[_c('div',{staticClass:"cut-border__inner"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }